import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
// import { AuthorizedLayoutModule } from './ui/authorized-layout/authorized-layout.module';
// import { FooterModule } from './ui/footer/footer.module';
// import { LayoutModule } from './ui/layout/layout.module';
// import { NotFoundModule } from './ui/not-found/not-found.module';
import { SplashScreenComponent } from './ui/splash-screen/splash-screen.component';


const MODULES = [
  // FooterModule,
  // LayoutModule,
  // AuthorizedLayoutModule,
  // NotFoundModule,
]

@NgModule({
  declarations: [
    SplashScreenComponent
  ],
  imports: [
    CommonModule,
    ...MODULES,
  ],
  exports: [
    RouterModule,
    ...MODULES,
    SplashScreenComponent
  ],
})
export class ShellModule { }
